import React from 'react';
import { useTranslation } from 'react-i18next';
import './PilotCodeOfConductText.css';

const MAIN_KEYS = ['px1', 'px2', 'px3', 'px4', 'px5', 'px6'];
const SAFETY_SUB_KEYS = ['px7i', 'px7ii', 'px7iii', 'px7iv', 'px7v'];

export default function PassengerCodeOfConductText({ className = '', showTitle = true }) {
  const { t } = useTranslation();

  return (
    <div className={`pilot-code-of-conduct-text ${className}`.trim()}>
      {showTitle && (
        <h3 className="pilot-code-of-conduct-title">{t('easaCharter.paxCodeTitle')}</h3>
      )}
      <ol className="pilot-code-of-conduct-list">
        {MAIN_KEYS.map((key) => (
          <li key={key}>{t(`easaCharter.${key}`)}</li>
        ))}
        <li>
          {t('easaCharter.px7')}
          <ol className="pilot-code-of-conduct-sublist" type="i">
            {SAFETY_SUB_KEYS.map((key) => (
              <li key={key}>{t(`easaCharter.${key}`)}</li>
            ))}
          </ol>
        </li>
      </ol>
    </div>
  );
}
